<template>
  <div class="footer">
    <div class="foot-left">
      <img class="logos" src="@/assets/img/logo@2x.png" alt="" />
      <div class="left-cont">
        <div class="cont-item">
          <img src="@/assets/img/phone@2x.png" alt="" />
          <span>86-10-62301618</span>
        </div>
        <div class="cont-item">
          <img src="@/assets/img/printer@2x.png" alt="" />
          <span>86-10-62304364</span>
        </div>
        <div class="cont-item">
          <img src="@/assets/img/Maps@2x.png" alt="" />
          <span>{{footer.address}}</span>
        </div>
        <div class="cont-item">
          <img src="@/assets/img/mail@2x.png" alt="" />
          <span>100191</span>
        </div>
      </div>
    </div>
    <div class="foot-head">
      
      <div class="foot-right">
        <div class="right-cont">
          <div class="cont-item">
            <div class="item-head" @click="toNew('/Interformation')">{{footer.InformationExchange}}</div>
            <div class="items">
              <div class="item" @click="toNew('/Interformation','section1')">{{footer.InternationalNews}}</div>
              <div class="item" @click="toNew('/Interformation','section2')">{{footer.GlobalTrends}}</div>
            </div>
          </div>
          <div class="cont-item">
            <div class="item-head" @click="toNew('/casedisplay')">{{footer.Industrydocking}}</div>
            <div class="items">
              <div class="item" @click="toNew('/casedisplay')">{{footer.SupplyAndDemandApplication}}</div>
              <div class="item">{{footer.RequirementsLibrary}}</div>
              <div class="item">{{footer.SupplyLibrary}}</div>
            </div>
          </div>
          <div class="cont-item">
            <div class="item-head" @click="toNew('/countryMe')">{{footer.ApplicationEmpowerment}}</div>
            <div class="items">
              <div class="item" @click="toNew('/countryMe')">{{footer.EnterpriseEmpowerment}}</div>
              <div class="item">{{footer.Technologyempowerment}}</div>
            </div>
          </div>
          <div class="cont-item">
            <div class="item-head" @click="toNew('/governance')">{{footer.GovernanceCooperation}}</div>
            <div class="items">
              <div class="item" @click="toNew('/governance','governZcfg')">{{footer.PoliciesAndRegulations}}</div>
              <div class="item" @click="toNew('/governance','governYjbg')">{{footer.ResearchReport}}</div>
              <div class="item" @click="toNew('/governance','governGjzl')">{{footer.InternationalGovernance}}</div>
              <div class="item" @click="toNew('/governance','governGjbz')">{{footer.InternationalStandards}}</div>
            </div>
          </div>
          <div class="cont-item">
            <div class="item-head" @click="toNew('/Centraloutcome')">{{footer.CenterAchievements}}</div>
            <div class="items">
              <div class="item" @click="toNew('/Centraloutcome','zxcg','会议')">{{footer.Meeting}}</div>
              <div class="item" @click="toNew('/Centraloutcome','zxcg','活动')">{{footer.Activity}}</div>
              <div class="item" @click="toNew('/Centraloutcome','zxcg','白皮书')">{{footer.whitepaper}}</div>
              <div class="item" @click="toNew('/Centraloutcome','zxcg','蓝皮书')">{{footer.BlueBook}}</div>
              <div class="item" @click="toNew('/Centraloutcome','zxcg','标准')">{{footer.standard}}</div>
            </div>
          </div>
          <div class="cont-item">
            <div class="item-head" @click="toNew('/Aboutus')">{{footer.aboutUs}}</div>
            <div class="items">
              <div class="item" @click="toNew('/Aboutus','clbj')">{{footer.BackgroundOfEstablishment}}</div>
              <div class="item" @click="toNew('/Aboutus','zzjg')">{{footer.OrganizationalStructure}}</div>
              <div class="item" @click="toNew('/Aboutus','zxfw')">{{footer.CenterServices}}</div>
            </div>
          </div>
        </div>
        <div class="right-code">
          <img src="@/assets/img/code.jpg" alt="" />
          <div>{{footer.OfficialWeChatAccount}}</div>
        </div>
      </div>
    </div>
    <div class="foot-bottom">
      <span class="sp1">{{footer.copyright}}</span>
      <!-- <span class="sp2">京ICP备041221882220号-1</span>
      <span class="sp3">京公网安备111221882220号</span> -->
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  computed:{
    footer(){
      return this.$t('footer')
    }
  },
  mounted() {},
  methods:{
    toNew(path,ids,isSelect){
      if(ids){
        let parseUrl = {
          isPont:ids,
          isSelect:isSelect?isSelect:''
        }
        this.$bus.$emit('changePont',parseUrl)
        if(isSelect){
          this.$router.push({path:path,query:{isSelect:isSelect}})
        }else{
          this.$router.push({path:path}) 
        }
      }else{
        this.$router.push(path)
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.footer {
  width: 100%;
  background: #e9e9e9;
  display: flex;
  flex-direction: column;
  .foot-left {
    margin: 0 40px;
    padding-top: 20px;
    display: flex;
    align-items: center;
    border-bottom: 1px solid #cccccc;
    padding-bottom: 20px;
    justify-content:space-between;
    >img {
      height: 48px;
      margin-right: 20px;
    }
    .left-cont {
  
      display: flex;

      .cont-item {
        display: flex;
        align-items: center;
        height: 24px;
        margin-left: 30px;
        line-height: 24px;
        img {
          height: 16px;
        }
        span {
          font-size: 14px;
          color: #666666;
          text-align: left;
          margin-left: 5px;
        }
      }
      .cont-item:last-child {
        margin-bottom: 0;
      }
    }
  }
  .foot-head {
    // flex: 1;
    // padding: 50px 100px 40px 100px;
    // padding: 2% 5% 2% 5%;
    padding: 0 40px;
    margin-top: 30px;
    padding-bottom: 30px;
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
    border-bottom: 1px solid #cccccc;
    
    .foot-right {
      display: flex;
      flex: 1;
      .right-cont {
        flex: 1;
        display: flex;
        justify-content: space-between;
        .cont-item {
          width: calc(16.6% - 12px);
          display: flex;
          flex-direction: column;
          text-align: left;
          .item-head {
            cursor: pointer;
            font-size: 16px;
            color: #080808;
            line-height: 24px;
          }
          .items {
            margin-top: 20px;
            .item {
              font-size: 14px;
              color: #666666;
              line-height: 24px;
              cursor: pointer;
              margin-bottom: 20px;
            }
            .item:last-of-type{
                margin-bottom: 0px;
            }
          }
        }
      }
      .right-code {
        margin-left: 25px;
        img {
          height: 113px;
        }
        > div {
          height: 24px;
          font-size: 14px;
          color: #666666;
          line-height: 24px;
          text-align: center;
        }
      }
    }
  }
  .foot-bottom {
    height: 60px;
    display: flex;
    align-items: center;
    justify-content: center;
    span {
      font-size: 12px;
      color: #666666;
      line-height: 12px;
    }
    .sp2 {
      margin: 0 40px;
    }
  }
}
@media (min-width: 600px) and (max-width: 1040px) {
  .foot-head {
    display: none !important;
  }
}
@media (max-width: 600px) {
  .foot-left {
    display: none !important;
  }
  .foot-head {
    display: none !important;
  }
}
</style>
